import React from "react";
import PropTypes from "prop-types";
// Material imports
import Typography from "@mui/material/Typography";
//
import { getTimeRemaining } from "./TimerLabelUtil";
const DEFAULT_TIMEOUT = {
  timeString: "",
  seconds: null
};
const TimerLabel = ({
  expiry,
  color,
  refresh = 1000,
  timeoutText = "timeout",
  completed = false
}) => {
  const [timeLeft, setTimeLeft] = React.useState(expiry ? getTimeRemaining(expiry, timeoutText) : DEFAULT_TIMEOUT);
  React.useEffect(() => {
    const countdown = setTimeout(() => {
      const newTime = getTimeRemaining(expiry, timeoutText);
      if (newTime.seconds > 0) {
        setTimeLeft(newTime);
      } else {
        setTimeLeft(newTime);
        clearTimeout(countdown);
      }
    }, refresh);
  });
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: timeLeft.seconds > 0 && !completed ? "textPrimary" : color,
    component: "label"
  }, !completed ? timeLeft.timeString : "completed");
};
TimerLabel.propTypes = {
  expiry: PropTypes.number,
  color: PropTypes.string,
  refresh: PropTypes.number,
  timeoutText: PropTypes.string,
  completed: PropTypes.bool
};
export default TimerLabel;